import React, { lazy, Suspense } from "react";
import { LazyLoader } from "../../../../assets/loaders";

const LazyComponent = lazy(() => import("./Branches"));

export default function Branches() {
  return (
    <Suspense fallback={<LazyLoader />}>
      <LazyComponent />
    </Suspense>
  );
}
